/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportPublicHolidaysResponse
 */
export interface ImportPublicHolidaysResponse {
    /**
     * 
     * @type {number}
     * @memberof ImportPublicHolidaysResponse
     */
    addedCount: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ImportPublicHolidaysResponse
     */
    importedYears: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ImportPublicHolidaysResponse
     */
    skippedYears: Array<number>;
}

/**
 * Check if a given object implements the ImportPublicHolidaysResponse interface.
 */
export function instanceOfImportPublicHolidaysResponse(value: object): value is ImportPublicHolidaysResponse {
    if (!('addedCount' in value) || value['addedCount'] === undefined) return false;
    if (!('importedYears' in value) || value['importedYears'] === undefined) return false;
    if (!('skippedYears' in value) || value['skippedYears'] === undefined) return false;
    return true;
}

export function ImportPublicHolidaysResponseFromJSON(json: any): ImportPublicHolidaysResponse {
    return ImportPublicHolidaysResponseFromJSONTyped(json, false);
}

export function ImportPublicHolidaysResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportPublicHolidaysResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'addedCount': json['addedCount'],
        'importedYears': json['importedYears'],
        'skippedYears': json['skippedYears'],
    };
}

export function ImportPublicHolidaysResponseToJSON(json: any): ImportPublicHolidaysResponse {
    return ImportPublicHolidaysResponseToJSONTyped(json, false);
}

export function ImportPublicHolidaysResponseToJSONTyped(value?: ImportPublicHolidaysResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addedCount': value['addedCount'],
        'importedYears': value['importedYears'],
        'skippedYears': value['skippedYears'],
    };
}

